import { render } from "./RegisterModalComponent.vue?vue&type=template&id=e5dc9d26&scoped=true&ts=true"
import script from "./RegisterModalComponent.vue?vue&type=script&lang=ts"
export * from "./RegisterModalComponent.vue?vue&type=script&lang=ts"

import "./RegisterModalComponent.vue?vue&type=style&index=0&id=e5dc9d26&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5dc9d26"]])

export default __exports__